import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import {
  BrandSegmentBadge as BrandSegmentBadgePFC,
  BrandSegmentBadgeProps,
} from "components/ui/source/components/BrandSegmentBadge/BrandSegmentBadge";

export const BrandSegmentBadge = (props: BrandSegmentBadgeProps) => {
  const { analytics } = useAnalyticsTracker();

  return (
    <BrandSegmentBadgePFC
      onHover={() =>
        analytics.track("Brand Segment description hovered", {
          brandSegment: props.brandSegment,
        })
      }
      {...props}
    />
  );
};
